import { render } from "./StatViewManagerAreaScreen.vue?vue&type=template&id=1deeb196&scoped=true"
import script from "./StatViewManagerAreaScreen.vue?vue&type=script&lang=js"
export * from "./StatViewManagerAreaScreen.vue?vue&type=script&lang=js"

import "./StatViewManagerAreaScreen.vue?vue&type=style&index=0&id=1deeb196&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1deeb196"]])

export default __exports__